import { Component, Inject } from "@angular/core";
import { FormGroup, ValidationErrors } from "@angular/forms";
import { TranslationHelperService } from "@nms-ng2/app/shared/services/util/translation-helper.service";
import libphonenumber from "google-libphonenumber";
import { CountryISO, PhoneNumberFormat, SearchCountryField } from "ngx-intl-tel-input";
import { tap, throttleTime } from "rxjs/operators";

/**
 * Componente que representa a aba de dados do usuário.
 */
@Component({
    templateUrl: "./user-data.component.html",
    styleUrls: ["./user-data.component.scss"]
})
export class UserDataComponent {
    searchCountryField: SearchCountryField[] = [SearchCountryField.Iso2, SearchCountryField.Name];
    numberFormat: PhoneNumberFormat = PhoneNumberFormat.International;
    selectedCountryISO: CountryISO = CountryISO.Brazil;
    preferredCountries: CountryISO[] = [CountryISO.Brazil, CountryISO.UnitedStates, CountryISO.UnitedKingdom];
    userDataForm: FormGroup;

    constructor(@Inject("isLdapMode") public isLdapMode: boolean,
                @Inject("formControl") public formControl: FormGroup,
                private readonly translationHelper: TranslationHelperService) {
        this.userDataForm = formControl;
        this.userDataForm.valueChanges
            .pipe(
                throttleTime(200),
                tap((field) => {
                    if (field.phone && this.userDataForm.get("phone").valid) {
                        const phoneValue = this.userDataForm.get("phone").value;
                        field.phone.number = field.phone.nationalNumber;
                        this.userDataForm.get("phone").setValue(phoneValue);
                    }
                })
            )
            .subscribe((x) => {});
    }

    phoneIsInvalid() {
        if (this.userDataForm.value.phone == null) {
            return false;
        }
        try {
            const region = this.userDataForm.value.phone.countryCode;
            const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance(region);
            const validNumber = phoneUtil.parseAndKeepRawInput(this.userDataForm.value.phone.number, region);
            return !phoneUtil.isValidNumber(validNumber);
        } catch (err) {
            return true;
        }
    }

    phoneExample() {
        const region = this.userDataForm.value.phone.countryCode;
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance(region);
        const { PhoneNumberFormat: PNF, PhoneNumberType: PNT } = libphonenumber;
        const exampleNumber = phoneUtil.getExampleNumberForType(region, PNT.MOBILE);

        if (exampleNumber) {
            return phoneUtil.format(exampleNumber, PNF.INTERNATIONAL);
        }
        return "";
    }

    getNameFieldErrors(): string {
        const controlErrors: ValidationErrors = this.userDataForm.get("name").errors;
        let error;

        if (controlErrors != null) {
            if (controlErrors["minlength"]) {
                error = this.translationHelper.translateWithReplacement(
                    "manage.user.notification.preferences.nameInvalidMinLength",
                    controlErrors["minlength"].requiredLength
                );
            } else if (controlErrors["maxlength"]) {
                error = this.translationHelper.translateWithReplacement(
                    "manage.user.notification.preferences.nameInvalidMaxLength",
                    controlErrors["maxlength"].requiredLength
                );
            } else if (controlErrors["pattern"]) {
                error = this.translationHelper.translateWithReplacement(
                    "manage.user.notification.preferences.invalidChars"
                );
            }
        }

        return error;
    }

}
